import React, {useEffect, useState} from "react";
import {Box, Button, Dialog, DialogTitle, Grid, Switch} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import CustomAlert from "../common/CustomAlert";
import {useGetAppointmentTimesQuery} from "../../store/rtk-api/appointment_times/appointment_times";
import {IAppDoctorTimesResult, ICreateAppTimesBody} from "../../store/rtk-api/appointment_times/types";
import {useAppDispatch, useTypedSelector} from "../../store";
import {setAlertOpen} from "../../store/calendar/calendar.slice";

type PropsType = {
    mainTexts: string[],
    btnText: string
    isWindowOpen: boolean,
    isLoading: boolean,
    isError: boolean,
    isSuccess: boolean,
    closeWindow(): void,
    handlePerform(body: ICreateAppTimesBody): void,
    dateTexts: any[],
    dateInfo: string,
    doctorId: number,
    clinicAddressId: number | null,
    doctor: IAppDoctorTimesResult

}


const AppointmentWindow: React.FC<PropsType> = ({
                                                    mainTexts,
                                                    isWindowOpen,
                                                    isLoading,
                                                    isError,
                                                    isSuccess,
                                                    closeWindow,
                                                    handlePerform,
                                                    btnText,
                                                    dateTexts,
                                                    doctorId,
                                                    dateInfo,
                                                    clinicAddressId,
                                                    doctor

                                                }) => {
    const [isReset, setIsReset] = useState(false);

    let arr: (number[] | undefined)[] = []
    if (doctor && !isReset) {
        arr = doctor?.appoint_times?.map(app_time => {
            if (app_time.times.length > 0 && app_time.date === dateInfo) return app_time.times.map(time => {
                return time.id
            })
        })
    }

    const {isAlertOpen} = useTypedSelector(state => state.calendar)
    const dispatch = useAppDispatch()
    const {addressId} = useTypedSelector(state => state.header)
    const {
        data: appointment_times,
        isError: appTimesError,
        isLoading: appTimesLoading
    } = useGetAppointmentTimesQuery({doctorId, addressId})
    const [timesMap, setTimesMap] = useState(new Map());

    const [activeTimesSet, setActiveTimesSet] = useState(new Set());
    const [flag, setFlag] = useState(false)
    const [isWeekday, setWeekDay] = useState(true)
    if (arr.length > 0) {
        arr.map(nums => {
            nums?.map(num => {
                if (num) {
                    activeTimesSet.add(num)
                }
            })
        })
    }
    if (appointment_times && !flag) {
        appointment_times.results?.map(time => {
            timesMap.set(time.id, false)
        })
    }
    if (activeTimesSet.size > 0) {
        Array.from(activeTimesSet).map(time => {
            timesMap.set(time, true)
        })
    }
    const handleClose = () => {
        closeWindow()
        dispatch(setAlertOpen(false))
    }
    const handlePerformFunction = () => {
        if (isWeekday) {
            handlePerform({
                doctor: doctorId,
                date: dateInfo,
                clinic_address: clinicAddressId,
                times: Array.from(activeTimesSet) as number[]
            })
        } else {
            handlePerform({
                doctor: doctorId,
                date: dateInfo,
                clinic_address: clinicAddressId,
                times: []
            })
        }

    }

    const changeTimeActivity = (id: number) => {
        setFlag(true)
        if (timesMap.get(id) === true) {
            setTimesMap(new Map(timesMap.set(id, false)))
            activeTimesSet.delete(id)
            setIsReset(true)
        } else {
            setTimesMap(new Map(timesMap.set(id, true)))
            activeTimesSet.add(id)
        }
    }

    //scroll actions
    const bottomRef = React.useRef<HTMLDivElement>(null);
    const scrollToBottom = () => {
        if (bottomRef.current) {
            bottomRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    };
    useEffect(() => {
        scrollToBottom()
    }, [isAlertOpen])

    return (
        <Dialog
            open={isWindowOpen}
            sx={{
                overflowY: "scroll",
                scrollBehavior: 'smooth'
            }}
        >
            <div ref={bottomRef} className="list-bottom"></div>
            {isLoading && <CircularProgress/>}
            {appTimesLoading && <CircularProgress/>}
            {isError && isAlertOpen && <CustomAlert title="Ошибка" status="error" message={"Что то пошло не так"}/>}
            {appTimesError && <CustomAlert title="Ошибка" status="error"
                                           message={"Произошла ошибка при подключении времени записи"}/>}
            {isSuccess && isAlertOpen &&
                <CustomAlert title="Успех" status="success" message="Операция успешно выполнено"/>}
            <DialogTitle id="alert-dialog-title">
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}>
                    <Box sx={{display: "flex", alignItems: "center", gap: "5px"}}>
                        {dateTexts?.length > 0 && dateTexts.map((date, ind) => {
                            return <Box sx={{fontWeight: 'bold'}} key={ind}>
                                {date}
                            </Box>
                        })}
                        {mainTexts?.length > 0 && mainTexts.map((text, ind) => {
                            return <Box sx={{fontWeight: 'bold'}} key={ind}>
                                {text}
                            </Box>
                        })}
                    </Box>
                    <CloseIcon sx={{cursor: 'pointer'}} onClick={handleClose}/>
                </Box>
            </DialogTitle>
            <Box sx={{
                minWidth: "400px",
                p: "20px",
                display: "flex",
            }}>
                <Box>
                    <Switch onChange={() => setWeekDay(!isWeekday)} checked={isWeekday}/>
                </Box>
                <Grid container rowGap={1} columnGap={1}>
                    {!isWeekday && <div>{dateInfo} - выходной</div>}
                    {isWeekday && appointment_times?.results?.map((item, ind) => {
                        return <Grid item lg={4} sx={timesMap.get(item.id) ?
                            {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "40px",
                                height: "40px",
                                border: "2px solid #5BA0CE",
                                borderRadius: "10px",
                                color: "secondary.light",
                                fontSize: "20px",
                                fontFamily: 600,
                                backgroundColor: "primary.main",
                                cursor: "pointer"
                            }
                            : {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "40px",
                                height: "40px",
                                border: "2px solid #5BA0CE",
                                borderRadius: "10px",
                                color: "primary.main",
                                fontSize: "20px",
                                fontFamily: 600,
                                cursor: "pointer"

                            }}
                                     key={item?.id}
                                     onClick={() => changeTimeActivity(item.id)}>
                            {item?.start_time.slice(0, 5)}
                        </Grid>
                    })}
                </Grid>
            </Box>
            <Box sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                overflow: "hidden",
                p: "30px"
            }}>
                <Button variant="contained"
                        color="primary"
                        size="large"
                        sx={{width: 120, height: 35, margin: 2, textTransform: 'lowercase'}}
                        onClick={handlePerformFunction}
                >
                    {btnText}
                </Button>
            </Box>
        </Dialog>
    )
}

export default AppointmentWindow